/// <amd-module name="Search/WorkItem/Components/Results" />
import * as React from "react";
import { IContainerProps } from "Search/Shared/Base/Container";
import { FilterPaneContainer } from "Search/WorkItem/Components/FilterPaneContainer";
import { OverlayContainer } from "Search/WorkItem/Components/Overlay";
import { ZeroDataContainer } from "Search/WorkItem/Components/ZeroData";
import { ActionCreator } from "Search/WorkItem/Flux/ActionCreator";
import { StoresHub, IAggregatedState, StoreName } from "Search/WorkItem/Flux/StoresHub";
import { SplitterContainer } from "Search/WorkItem/Components/Splitter";

export const ResultsContainer = (props: IContainerProps<StoreName, ActionCreator, IAggregatedState, StoresHub>) => {
    return (
        <div className="search-view-container flex-column flex-grow v-scroll-auto">
            <FilterPaneContainer {...props} />
            <div className="search-results flex-column flex-grow scroll-hidden relative">
                <OverlayContainer {...props} />
                <ZeroDataContainer {...props} />
                <SplitterContainer {...props} />
            </div>
        </div>);
}
